import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function MeasurementField({
  id,
  label,
  unit,
  value,
  onChange,
  placeholder,
  hint,
}: {
  id: string;
  label: string;
  unit: string;
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  hint?: string;
}) {
  return (
    <div className="space-y-2">
      <Label htmlFor={id} className="font-medium text-sm">
        {label}
      </Label>
      <div className="relative">
        <Input
          id={id}
          type="number"
          inputMode="decimal"
          step="any"
          value={value}
          onChange={(event) => onChange(event.target.value)}
          placeholder={placeholder}
          aria-describedby={hint ? `${id}-hint` : undefined}
          className="h-11 pr-12"
        />
        <span
          aria-hidden="true"
          className="pointer-events-none absolute top-3 right-3 text-muted-foreground text-sm"
        >
          {unit}
        </span>
      </div>
      {hint && (
        <p
          id={`${id}-hint`}
          className="text-muted-foreground text-xs leading-5"
        >
          {hint}
        </p>
      )}
    </div>
  );
}
